var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSta4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 60,
    viewBox: "0 0 64 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_704_8222)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.144 0.52475C38.0834 1.57431 38.7886 4.02329 37.5545 5.94749C36.4966 7.87169 34.0283 8.5714 32.0889 7.34691C30.1495 6.29734 29.4443 3.84837 30.6784 1.92417C31.7363 0.174895 34.2046 -0.524813 36.144 0.52475Z",
    fill: "url(#paint0_radial_704_8222)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.6155 0.699708C37.026 1.57434 37.5549 3.49854 36.6734 4.89796C35.7918 6.29738 33.8524 6.82216 32.442 5.94752C31.0315 5.07289 30.5026 3.14869 31.3841 1.74927C32.2656 0.349854 34.0287 -7.45058e-07 35.6155 0.699708Z",
    fill: "url(#paint1_radial_704_8222)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.3231 0.8746C34.5573 0.524746 35.7914 1.04953 35.9677 1.92416C36.144 2.7988 35.4388 3.84836 34.2046 4.19822C32.9705 4.54807 31.7363 4.02329 31.56 3.14865C31.3837 2.09909 32.0889 1.04953 33.3231 0.8746Z",
    fill: "url(#paint2_radial_704_8222)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.3784 2.09912C37.9073 3.14868 37.9073 4.5481 37.3784 5.59766C36.3205 7.34693 34.0285 8.04664 32.2654 6.99708C31.7365 6.64723 31.3839 6.29737 31.0312 5.94752C31.2076 6.12244 31.5602 6.29737 31.7365 6.4723C33.4996 7.52186 35.9679 6.82215 37.0257 5.07288C37.5547 4.19825 37.731 3.14868 37.3784 2.09912Z",
    fill: "url(#paint3_radial_704_8222)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5587 8.57142C32.2639 9.0962 33.1455 9.27113 33.6744 9.62098C34.5559 9.97084 35.4375 9.79591 35.7901 9.0962C36.1427 8.39649 35.9664 7.69678 35.2612 6.99708C34.7322 6.64722 34.2033 6.12244 33.3218 5.59766C32.4402 5.2478 31.735 4.89795 31.2061 4.72302C30.3245 4.37317 29.443 4.5481 29.0904 5.2478C28.7378 5.94751 28.9141 6.64722 29.6193 7.34693C30.1482 7.69678 30.6771 8.22157 31.5587 8.57142Z",
    fill: "url(#paint4_linear_704_8222)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.6744 9.62098C33.1455 9.44605 32.2639 9.0962 31.5587 8.57142C30.8535 8.04664 30.1482 7.69678 29.6193 7.172C29.2667 6.99707 29.0904 6.64722 28.9141 6.29737C28.9141 6.12244 28.9141 5.94751 28.9141 5.77258C29.0904 5.59766 29.0904 5.42273 29.2667 5.42273C29.6193 5.42273 29.9719 5.42273 30.3245 5.59766C30.8535 5.77258 31.735 6.12244 32.4402 6.64722C33.1455 7.172 33.8507 7.52185 34.3796 8.04664C34.7322 8.22156 34.9086 8.57142 35.0849 8.92127C35.0849 9.0962 35.0849 9.27113 35.0849 9.44605C34.9086 9.62098 34.9086 9.79591 34.7322 9.79591C34.3796 9.79591 34.027 9.62098 33.6744 9.62098Z",
    fill: "url(#paint5_radial_704_8222)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.6191 5.42265C29.6191 5.42265 29.6191 5.24773 29.6191 5.0728C30.5007 4.02324 34.5558 6.47222 34.5558 7.87163C33.3216 6.997 31.7348 5.77251 30.1481 5.59758C29.9718 5.42265 29.6191 5.42265 29.6191 5.42265Z",
    fill: "url(#paint6_radial_704_8222)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.6012 56.3265C42.1384 50.379 36.4966 49.6793 32.4415 46.7055C31.9125 46.3556 31.5599 46.0058 31.3836 45.6559C31.031 45.1312 31.031 44.6064 31.3836 44.0816C35.9676 37.0845 40.5516 29.0379 44.6067 21.3411C44.4304 22.0408 44.6067 22.7405 45.8409 23.6151C49.896 26.5889 55.5379 27.2886 64.0007 33.2361C58.7114 40.4081 53.4222 49.6793 50.6012 56.3265Z",
    fill: "url(#paint7_linear_704_8222)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.75
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.7074 31.6618C58.5339 29.7376 55.7129 28.3381 53.4209 27.2886C51.8342 30.962 49.7185 34.9854 47.4264 39.0087C44.9581 43.2069 42.4898 47.0553 40.0215 50.379C42.4898 51.4285 45.1344 52.653 48.308 54.7521C49.5421 50.9037 51.4815 46.7055 53.7735 42.6822C56.2419 38.4839 58.8865 34.8104 61.7074 31.6618Z",
    fill: "url(#paint8_linear_704_8222)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.9643 49.8542C39.4933 46.5306 41.08 42.3323 44.4299 36.5597C47.0745 31.8367 49.5429 28.688 51.8349 26.414C49.5429 25.3644 47.6035 24.6647 46.0167 23.4402C44.7825 22.5656 44.6062 21.8658 44.7825 21.1661C40.7274 29.0379 36.1434 36.9096 31.5594 43.9067C31.2068 44.4314 31.2068 44.9562 31.5594 45.481C31.7357 45.8309 32.0883 46.1807 32.6172 46.5306C34.3803 47.93 36.496 48.8046 38.9643 49.8542Z",
    fill: "url(#paint9_linear_704_8222)"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.3643 52.4781C44.783 47.2303 39.4937 46.3556 35.7913 43.7317C34.9097 43.2069 34.2045 42.8571 33.8519 42.3323C33.6756 41.9825 33.4993 41.6326 33.4993 41.4577C33.1466 41.9825 32.794 42.5072 32.4414 43.032C32.4414 43.3819 32.4414 43.7317 32.794 44.0816C33.1466 44.4314 33.6756 44.7813 34.3808 45.3061C38.2596 48.1049 43.7252 48.9795 51.659 54.4023C51.8353 53.7026 52.0117 53.0029 52.3643 52.4781ZM51.8353 28.8629C49.0144 27.6384 46.7224 26.7638 44.9593 25.3644C44.0778 24.6647 43.7252 24.1399 43.7252 23.6151C43.3725 24.3148 43.0199 24.8396 42.6673 25.5393C42.6673 26.0641 43.0199 26.5889 43.7252 27.1137C45.4882 28.3381 47.6039 29.2128 50.2486 30.4373C53.2458 32.0116 57.1246 33.411 61.7086 36.7346C62.0612 36.2099 62.4139 35.6851 62.9428 34.9854C58.3588 31.8367 54.8326 30.2623 51.8353 28.8629Z",
    fill: "url(#paint10_linear_704_8222)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.7252 26.9387C45.1356 27.9883 46.8987 28.8629 49.0144 29.7376C49.5433 29.2128 49.896 28.688 50.4249 28.1632C48.3092 27.2886 46.5461 26.4139 44.9593 25.3644C44.0778 24.6647 43.7252 24.1399 43.7252 23.6151C43.3725 24.3148 43.0199 24.8396 42.6673 25.5393C42.6673 25.8892 43.0199 26.4139 43.7252 26.9387ZM40.0227 46.0058C38.4359 45.3061 37.0254 44.6064 35.7913 43.7317C34.9097 43.2069 34.2045 42.8571 33.8519 42.3323C33.6756 41.9825 33.4993 41.6326 33.4993 41.4577C33.1466 41.9825 32.794 42.5072 32.4414 43.032C32.4414 43.3819 32.4414 43.7317 32.794 44.0816C33.1466 44.4314 33.6756 44.7813 34.3808 45.3061C35.7913 46.3556 37.5544 47.0553 39.6701 47.93C39.4937 47.2303 39.6701 46.5306 40.0227 46.0058Z",
    fill: "url(#paint11_linear_704_8222)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.4958 41.8075C39.6693 37.6093 47.6032 24.8396 50.0715 18.5422C49.7189 19.2419 48.4847 19.5918 47.4269 19.9417C46.369 20.2915 45.1349 20.4664 44.7823 21.3411C40.7272 29.0379 35.6142 37.6093 31.3828 43.9067C31.9117 43.3819 33.1459 43.207 34.0274 43.032C34.909 42.8571 35.9668 42.5072 36.4958 41.8075Z",
    fill: "url(#paint12_linear_704_8222)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.6719 41.9825C39.8455 37.7842 47.6031 24.8396 49.8951 18.7172C50.0714 18.0175 49.8951 17.3178 48.6609 16.4431C45.6637 14.344 40.3744 12.4198 34.3799 9.27112L20.9805 32.3615C26.975 35.5102 32.2642 37.2595 35.2615 39.5335C35.9667 40.0583 37.2009 41.1079 36.6719 41.9825Z",
    fill: "url(#paint13_linear_704_8222)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.662 16.4431C48.1331 16.0933 47.4278 15.7434 46.8989 15.2186C45.1358 19.067 42.8438 23.4402 40.3755 27.8134C38.0835 31.6618 35.7915 35.1603 33.6758 38.309C34.381 38.6589 34.9099 39.0087 35.4389 39.3586C36.1441 39.8834 37.3783 40.9329 36.673 41.8076C39.8466 37.6093 47.6042 24.6647 49.8962 18.5422C50.2488 18.0175 49.8962 17.3178 48.662 16.4431Z",
    fill: "url(#paint14_linear_704_8222)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.6586 30.962C53.7743 32.0116 56.2426 33.0612 59.0636 34.8104C59.4162 34.2857 59.9451 33.7609 60.2977 33.2361C57.3005 31.4868 54.8321 30.2623 52.5401 29.2128C52.3638 29.7375 52.0112 30.4373 51.6586 30.962ZM49.7192 50.7288C46.8983 48.9795 44.4299 47.93 42.3142 47.0553C41.9616 47.5801 41.609 48.2798 41.0801 48.8046C43.3721 49.8542 45.8404 50.9037 48.8377 52.8279C49.1903 51.9533 49.5429 51.4285 49.7192 50.7288Z",
    fill: "url(#paint15_linear_704_8222)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.0185 13.2944C40.5502 12.07 37.5529 10.8455 34.5557 9.27112L21.1562 32.3615C24.3298 34.1108 27.327 35.3353 29.9717 36.5597C31.7348 33.7609 33.3215 30.9621 35.0846 28.1632C37.9056 22.9154 40.5502 18.0175 43.0185 13.2944Z",
    fill: "url(#paint16_linear_704_8222)"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1568 32.1865C23.8014 33.5859 26.2697 34.6355 28.3854 35.6851C31.3827 37.0845 33.851 38.134 35.4378 39.3585C36.143 39.8833 36.4956 40.2332 36.6719 40.583C36.8482 40.9329 36.8482 41.4577 36.6719 41.8075C36.4956 42.3323 36.143 42.5072 35.4378 42.8571C34.9088 43.032 34.3799 43.2069 33.851 43.3819C33.3221 43.5568 32.7931 43.7317 32.2642 43.9066C31.9116 44.0816 31.559 44.2565 31.3827 44.6063C31.2064 44.7813 31.2064 45.1311 31.3827 45.481C31.559 45.8308 31.9116 46.1807 32.4405 46.5305C34.0273 47.755 36.143 48.6297 38.435 49.5043C41.7849 50.9037 45.4874 52.8279 50.424 56.1515C50.2477 56.3265 50.0714 56.3265 49.8951 56.3265C45.1347 53.0029 41.4323 51.2536 38.2587 49.8542C35.9667 48.8046 33.851 47.93 32.2642 46.7055C31.559 46.1807 31.2064 45.8308 31.0301 45.481C30.8537 45.1311 30.8537 44.6063 31.0301 44.2565C31.2064 43.7317 31.559 43.5568 32.2642 43.2069C32.7931 43.032 33.3221 42.8571 33.851 42.6821C34.3799 42.5072 34.9088 42.3323 35.4378 42.1574C35.7904 41.9824 36.143 41.8075 36.3193 41.4577C36.4956 41.2827 36.4956 40.9329 36.3193 40.583C36.143 40.2332 35.7904 39.8833 35.2615 39.5335C33.4984 38.309 31.2064 37.2594 28.2091 35.86C25.9171 34.8104 23.4488 33.7609 20.9805 32.3615L21.1568 32.1865Z",
    fill: "url(#paint17_linear_704_8222)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.7305 36.035C34.7333 33.9358 29.2677 32.0116 23.0969 28.688L22.0391 30.4373C28.0336 33.586 33.4991 35.5102 36.4964 37.6093C37.2016 38.1341 38.4358 39.1836 37.7305 40.0583C38.0831 39.5335 38.4358 39.0087 38.9647 38.309C39.4936 37.6093 38.4358 36.7347 37.7305 36.035ZM49.1906 20.6414C49.3669 19.9417 49.1906 19.242 47.9564 18.3673C44.9592 16.2682 39.4936 14.344 33.4991 11.0204L32.4413 12.7697C38.6121 16.0933 44.0776 18.0175 47.0749 20.1166C48.1327 20.9912 48.6617 21.6909 48.309 22.3906C48.6617 21.8659 48.838 21.1662 49.1906 20.6414Z",
    fill: "url(#paint18_linear_704_8222)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.1892 20.6414C49.3655 19.9417 49.1892 19.2419 47.955 18.3673C47.4261 18.0175 46.7209 17.4927 46.0156 17.1428C45.663 17.6676 45.4867 18.3673 45.1341 19.067C45.8393 19.4169 46.5446 19.7667 47.0735 20.2915C48.1313 21.1661 48.6603 21.8659 48.3077 22.5656C48.6603 21.8659 48.8366 21.1661 49.1892 20.6414ZM38.9633 38.6589C39.4922 37.7842 38.4344 36.7347 37.7291 36.2099C37.2002 35.86 36.6713 35.5102 35.9661 35.1603C35.6134 35.6851 35.2608 36.3848 34.9082 36.9096C35.6134 37.2594 36.1424 37.6093 36.6713 37.9592C37.3765 38.4839 38.6107 39.5335 37.9054 40.4081C38.2581 39.7084 38.6107 39.1836 38.9633 38.6589Z",
    fill: "url(#paint19_linear_704_8222)"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.4413 12.7697C35.6148 14.344 38.6121 15.7434 41.0804 16.9679C41.433 16.4431 41.7856 15.7434 41.9619 15.2186C39.4936 13.9941 36.4964 12.7697 33.3228 11.1953L32.4413 12.7697ZM31.9123 33.0612C29.2677 31.8367 26.2705 30.6122 23.0969 28.863L22.0391 30.6122C25.2126 32.3615 28.2099 33.586 30.8545 34.8105C31.2071 34.2857 31.5597 33.586 31.9123 33.0612Z",
    fill: "url(#paint20_linear_704_8222)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.4398 6.99702C33.3214 7.5218 33.8503 8.04658 34.3792 8.39644C34.7318 8.92122 35.0844 9.27107 34.9081 9.446C32.6161 13.2944 30.1478 17.4926 28.0321 21.341C25.7401 25.1894 23.6244 29.0378 21.3324 32.7113C20.2745 32.1865 19.393 31.6617 18.3351 30.962C17.2773 30.4373 16.3957 29.9125 15.3379 29.2128C17.6299 25.5393 19.9219 21.6909 22.0376 17.8425C24.3296 13.9941 26.6216 9.62093 28.9136 5.77253C29.09 5.5976 29.4426 5.42268 30.1478 5.5976C30.853 6.12239 31.7346 6.47224 32.4398 6.99702Z",
    fill: "url(#paint21_linear_704_8222)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4495 18.1924C25.7415 14.344 28.2098 9.97087 30.3255 5.94754C29.7966 5.77262 29.2677 5.77262 29.0914 6.12247C26.9757 9.79594 24.6837 13.9942 22.568 17.6677C22.2153 18.1924 21.8627 18.7172 21.5101 19.4169C19.5707 22.7405 17.455 26.2391 15.5156 29.5627C15.6919 29.3878 16.2209 29.2128 16.7498 29.3878C19.0418 25.7143 21.1575 22.0408 23.4495 18.1924Z",
    fill: "url(#paint22_linear_704_8222)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.0308 6.29736C28.7388 10.3207 26.2705 14.6939 23.9785 18.5423C21.8628 22.2157 19.5708 25.8892 17.4551 29.5627C17.984 29.7376 18.3366 29.9125 18.8655 30.2624C19.0419 30.2624 19.0419 30.4373 19.2182 30.4373C21.3339 26.7638 23.4496 23.0904 25.7416 19.4169C28.0336 15.3936 30.6782 11.0204 32.7939 6.99707C32.6176 6.99707 32.7939 6.99707 32.4413 6.82214C32.265 6.82214 31.5598 6.47229 31.0308 6.29736Z",
    fill: "url(#paint23_linear_704_8222)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.8512 7.8717C31.5591 11.7201 29.0908 16.2682 26.7988 20.1166C24.6831 23.7901 22.5674 27.4635 20.2754 31.137C20.9806 31.8367 21.5096 32.3615 21.3332 32.7114C23.6253 28.863 25.741 25.0146 28.033 21.3411C28.033 21.1662 28.2093 20.9912 28.2093 20.8163C30.325 17.1428 32.7933 12.9446 34.909 9.27112C35.0853 9.09619 34.909 8.57141 34.3801 8.22156C34.2038 8.22156 34.0275 8.04663 33.8512 7.8717Z",
    fill: "url(#paint24_linear_704_8222)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8656 30.2623C20.4524 31.137 21.5103 32.3614 21.334 32.8862C20.9813 33.411 19.5709 33.0611 17.8078 32.1865C16.221 31.3119 15.1632 30.0874 15.3395 29.5626C15.6921 29.0378 17.2789 29.3877 18.8656 30.2623Z",
    fill: "#A71B00"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8044 32.8863C18.5124 36.5598 17.9835 37.2595 15.8678 40.933C13.7521 44.7813 7.40496 55.9767 5.28926 59.6502C4.40771 59.1254 3.52617 58.6006 2.64463 58.0758C1.76309 57.726 0.881543 57.2012 0 56.6764C2.29201 53.0029 8.81543 41.8076 10.9311 38.1341C13.0468 34.4606 13.5758 33.586 15.5152 29.9125C15.8678 29.7376 16.2204 29.5627 16.7493 29.7376C17.2782 29.9125 17.9835 30.0875 18.6887 30.6123C19.3939 30.9621 19.9229 31.4869 20.4518 31.8367C20.8044 32.3615 20.9807 32.7114 20.8044 32.8863Z",
    fill: "url(#paint25_linear_704_8222)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4521 31.8367C20.2758 31.4868 19.9231 31.3119 19.3942 30.962C17.1022 34.8104 16.5733 35.6851 14.2813 39.5335C11.9893 43.3819 5.46584 54.7521 3.17383 58.6005C3.87906 58.9504 4.40799 59.3002 5.11322 59.6501C7.40523 55.9766 13.7523 44.7813 15.868 40.9329C17.9837 37.2594 18.5127 36.5597 20.8047 32.8862C20.981 32.7113 20.8047 32.3615 20.4521 31.8367Z",
    fill: "url(#paint26_linear_704_8222)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.705234 57.2012C2.99725 53.3528 9.69697 42.1574 11.989 38.309C14.281 34.4606 14.6336 33.7609 16.7493 29.9125C16.2204 29.7376 15.8678 29.9125 15.6915 30.0875C13.5758 33.9359 13.2231 34.6356 11.1074 38.309C8.81543 41.9825 2.29201 53.0029 0 56.6764C0.352617 56.8513 0.528926 57.0262 0.705234 57.2012Z",
    fill: "url(#paint27_linear_704_8222)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.17301 57.376C4.58348 58.2507 5.64133 59.3002 5.28871 59.6501C5.1124 60.1748 3.70193 59.825 2.29147 58.9504C0.880998 58.0757 -0.176853 57.0262 0.175764 56.6763C0.352073 56.3265 1.58623 56.6763 3.17301 57.376Z",
    fill: "url(#paint28_radial_704_8222)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6887 30.4373C18.1598 30.0874 17.6309 29.9125 17.1019 29.7375C11.1074 40.2332 3.70248 53.1778 4.0551 53.3527C4.40772 53.7026 12.5179 41.1078 18.6887 30.4373Z",
    fill: "url(#paint29_radial_704_8222)"
  }))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.6255 29.0379C23.9781 28.5131 22.744 27.2886 21.1572 26.414C19.923 25.7143 18.5126 25.1895 17.9836 25.5393C17.631 26.0641 17.2784 26.7638 16.9258 27.2886C17.4547 26.9387 18.8652 27.4635 20.2756 28.1632C21.8624 29.0379 22.9203 30.2624 22.744 30.7871C22.9203 30.2624 23.2729 29.5627 23.6255 29.0379ZM30.3252 10.4956C31.0305 10.8454 33.1462 12.4198 32.7935 13.1195C33.1462 12.5947 33.4988 11.895 33.8514 11.3702C34.204 10.6705 32.0883 9.09618 31.3831 8.74632C30.8542 8.39647 28.7385 7.34691 28.0332 7.87169C27.6806 8.39647 27.328 9.09618 26.9754 9.62096C27.8569 9.2711 29.7963 10.1457 30.3252 10.4956Z",
    fill: "url(#paint30_linear_704_8222)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.0917 9.7959C29.6206 9.97083 30.1495 10.3207 30.5021 10.4956C30.5021 10.4956 30.6784 10.6705 30.8547 10.6705C31.2074 10.1458 31.56 9.44605 31.9126 8.92127C31.7363 8.92127 31.7363 8.74634 31.56 8.74634C31.3837 8.57141 30.6784 8.39649 30.1495 8.04663C29.6206 8.74634 29.4443 9.27112 29.0917 9.7959ZM21.5104 26.5889C21.3341 26.5889 21.3341 26.414 21.1578 26.414C20.6288 26.2391 20.2762 25.8892 19.7473 25.7143C19.3947 26.2391 19.0421 26.9388 18.6895 27.4635C19.2184 27.6385 19.571 27.8134 20.0999 28.1632C20.2762 28.1632 20.2762 28.3382 20.4525 28.3382C20.8052 27.8134 21.1578 27.2886 21.5104 26.5889Z",
    fill: "url(#paint31_linear_704_8222)"
  }))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1522 9.62095C27.3285 9.44602 27.8574 9.44602 28.3864 9.62095C28.739 9.09616 29.0916 8.39646 29.4442 7.87167C28.9153 7.69675 28.5627 7.69675 28.2101 7.87167C27.8574 8.39646 27.5048 8.92124 27.1522 9.62095ZM19.042 25.5393C18.5131 25.3644 18.1605 25.3644 17.8079 25.5393C17.4552 26.0641 17.1026 26.7638 16.75 27.2886C16.9263 27.1137 17.4552 27.1137 17.9842 27.2886C18.3368 26.7638 18.6894 26.0641 19.042 25.5393Z",
    fill: "url(#paint32_linear_704_8222)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5676 27.4635C22.215 27.9883 21.8624 28.688 21.5098 29.2128C22.215 29.9125 22.7439 30.4373 22.5676 30.7872C22.9202 30.2624 23.2729 29.5627 23.6255 29.0379C23.8018 28.688 23.2729 27.9883 22.5676 27.4635ZM31.7357 11.5452C32.4409 12.07 32.9698 12.7697 32.7935 13.1195C33.1461 12.5947 33.4987 11.895 33.8514 11.3702C34.0277 11.0204 33.4987 10.3207 32.7935 9.7959C32.4409 10.3207 32.0883 10.8455 31.7357 11.5452Z",
    fill: "url(#paint33_linear_704_8222)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_704_8222",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.6272 2.42795) rotate(29.806) scale(5.51952 5.49773)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCD10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2207,
    stopColor: "#EDAB09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4492,
    stopColor: "#E08E02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5799,
    stopColor: "#DB8300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7066,
    stopColor: "#D67D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8778,
    stopColor: "#C86C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA5B00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_704_8222",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.4094 0.297451) rotate(29.8059) scale(6.71869 6.69217)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE58A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_704_8222",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.871 -1.60122) rotate(29.806) scale(6.63212 6.60594)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE58A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_704_8222",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.7377 3.53446) rotate(29.806) scale(6.37012 6.34496)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE58A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_704_8222",
    x1: 29.0191,
    y1: 5.16611,
    x2: 35.7583,
    y2: 9.08753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0520446,
    stopColor: "#ED9500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4033,
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9257,
    stopColor: "#B36600"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_704_8222",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.3877 9.5755) scale(15.0947 14.9764)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E38812"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1088,
    stopColor: "#E6962D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7298,
    stopColor: "#F8E1C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_704_8222",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.5252 4.61659) scale(5.38605 5.34385)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF0B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_704_8222",
    x1: 37.6773,
    y1: 33.5433,
    x2: 57.2475,
    y2: 44.9314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6896,
    stopColor: "#FC3F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4020B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_704_8222",
    x1: 44.0105,
    y1: 37.0444,
    x2: 55.2233,
    y2: 43.5693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1307,
    stopColor: "#3E1111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3149,
    stopColor: "#902727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4663,
    stopColor: "#CC3737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5772,
    stopColor: "#F14141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6357,
    stopColor: "#FF4545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6842,
    stopColor: "#F24040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.774,
    stopColor: "#D03333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.894,
    stopColor: "#991D1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#630808"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_704_8222",
    x1: 37.6768,
    y1: 33.5433,
    x2: 45.7349,
    y2: 38.2325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.1e-7,
    stopColor: "#800C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE4BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_704_8222",
    x1: 37.6868,
    y1: 33.7179,
    x2: 56.9852,
    y2: 44.9479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0743494,
    stopColor: "#B36600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5967,
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.948,
    stopColor: "#ED9500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_704_8222",
    x1: 37.6995,
    y1: 33.725,
    x2: 44.7029,
    y2: 37.8004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5743,
    stopColor: "#FFA163"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE4BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_704_8222",
    x1: 39.2053,
    y1: 30.4903,
    x2: 42.6568,
    y2: 32.4987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#960007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#610000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_704_8222",
    x1: 27.8285,
    y1: 20.6543,
    x2: 44.1506,
    y2: 30.1521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7454,
    stopColor: "#FC3F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4020B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_704_8222",
    x1: 39.7916,
    y1: 27.5064,
    x2: 44.1987,
    y2: 30.0711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.684,
    stopColor: "#FF7373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7379,
    stopColor: "#F26D6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8374,
    stopColor: "#D05E5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9708,
    stopColor: "#994545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C3F3F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_704_8222",
    x1: 46.9751,
    y1: 38.7435,
    x2: 54.5756,
    y2: 43.1664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0181897,
    stopColor: "#0F0E0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0984447,
    stopColor: "#4E4936"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1779,
    stopColor: "#847C5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2546,
    stopColor: "#B0A67A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328,
    stopColor: "#D2C691"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3973,
    stopColor: "#EBDDA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4607,
    stopColor: "#FAEBAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.513,
    stopColor: "#FFF0B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5585,
    stopColor: "#F9EAAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6194,
    stopColor: "#E8DAA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.689,
    stopColor: "#CCC08D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7651,
    stopColor: "#A59B72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8466,
    stopColor: "#736C4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9311,
    stopColor: "#373326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_704_8222",
    x1: 27.9096,
    y1: 20.5142,
    x2: 40.913,
    y2: 28.0809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.1e-7,
    stopColor: "#FF3030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE4BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_704_8222",
    x1: 19.5659,
    y1: 34.8531,
    x2: 52.096,
    y2: 53.7826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4020B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC3F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_704_8222",
    x1: 27.8331,
    y1: 20.6477,
    x2: 43.9884,
    y2: 30.0486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0743494,
    stopColor: "#B36600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5967,
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.948,
    stopColor: "#ED9500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_704_8222",
    x1: 39.9552,
    y1: 27.5923,
    x2: 44.0349,
    y2: 29.9664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF0B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_704_8222",
    x1: 27.9084,
    y1: 20.5182,
    x2: 36.3481,
    y2: 25.4294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.1e-7,
    stopColor: "#FFA163"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE4BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_704_8222",
    x1: 22.4928,
    y1: 17.3954,
    x2: 28.35,
    y2: 20.8037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#FC3F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4020B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_704_8222",
    x1: 22.4253,
    y1: 17.5148,
    x2: 23.4495,
    y2: 18.1107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.1e-7,
    stopColor: "#800C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE4BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_704_8222",
    x1: 23.7943,
    y1: 17.6071,
    x2: 26.7375,
    y2: 19.3196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0863509,
    stopColor: "#3E1111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2081,
    stopColor: "#902727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3082,
    stopColor: "#CC3737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3814,
    stopColor: "#F14141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4201,
    stopColor: "#FF4545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4973,
    stopColor: "#F24040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6402,
    stopColor: "#D03333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8313,
    stopColor: "#991D1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#630808"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_704_8222",
    x1: 26.8609,
    y1: 19.9779,
    x2: 28.333,
    y2: 20.8346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE4BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#800C0C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_704_8222",
    x1: 8.08498,
    y1: 42.9151,
    x2: 13.2828,
    y2: 45.9398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#546578"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316,
    stopColor: "#8DA0B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#546578"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_704_8222",
    x1: 11.0695,
    y1: 44.6473,
    x2: 12.962,
    y2: 45.7486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5242,
    stopColor: "#C3CEE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A9FC2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_704_8222",
    x1: 8.01463,
    y1: 43.0361,
    x2: 10.904,
    y2: 44.7174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A9FC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4758,
    stopColor: "#C3CEE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_704_8222",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1.35368 53.4456) scale(7.1405 7.08454)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADBDC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#263754"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_704_8222",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-5.66514 29.2171) scale(27.5591 27.3432)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1102,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2341,
    stopColor: "#EDEDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3647,
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4999,
    stopColor: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6388,
    stopColor: "#8E8E8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7807,
    stopColor: "#5C5C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9223,
    stopColor: "#232323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_704_8222",
    x1: 22.6168,
    y1: 17.2723,
    x2: 24.9356,
    y2: 18.6215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0743494,
    stopColor: "#B36600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5967,
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.948,
    stopColor: "#ED9500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_704_8222",
    x1: 24.4033,
    y1: 17.7624,
    x2: 26.0698,
    y2: 18.7322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF0B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_704_8222",
    x1: 22.592,
    y1: 17.3167,
    x2: 23.5345,
    y2: 17.865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.1e-7,
    stopColor: "#FFA163"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE4BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_704_8222",
    x1: 26.9491,
    y1: 19.8421,
    x2: 28.4144,
    y2: 20.6949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.1e-7,
    stopColor: "#FFE4BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA163"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_704_8222"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 60,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSta4);
export default __webpack_public_path__ + "static/media/sta_4.85a229e1f1904d62325803557abfa779.svg";
export { ForwardRef as ReactComponent };